import { CreateOrderModel, OrderConfirmationInfoModel, OrderConfirmationRequestModel, OrderCreatedModel, OrderInfoModel, OrderModel } from '@/types/api'
import { createUrlQuery } from '@/utils/apiHelper'
import { baseApi } from './baseApi'

export const orderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrder: builder.query<OrderInfoModel, number>({
      query: (id) => `Order/${id}`,
    }),
    getOrders: builder.query<OrderModel[], void>({
      query: () => `Order`,
      providesTags: ['Order']
    }),
    getPaymentStatus: builder.query<boolean, number>({
      query: (id) => `Order/Status/${id}`,
    }),
    getConfirmationInfo: builder.query<OrderConfirmationInfoModel, OrderConfirmationRequestModel>({
      query: (payload) => `OrderConfirmation?${createUrlQuery(payload)}`,
      keepUnusedDataFor: 3600,
    }),
    createOrder: builder.mutation<OrderCreatedModel, CreateOrderModel>({
      query: (payload) => ({
        url: `Order`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Cart'],
    }),
  }),
})

export const {
  useGetOrderQuery,
  useGetOrdersQuery,
  useGetPaymentStatusQuery,
  useCreateOrderMutation,
  useGetConfirmationInfoQuery,
  useLazyGetConfirmationInfoQuery,
  useLazyGetOrderQuery,
  util: { getRunningQueriesThunk },
} = orderApi

export const { getConfirmationInfo } = orderApi.endpoints